module.exports = __webpack_public_path__ + "static/img/logo-branco.20e6dbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-branco.png
// module id = R7PX
// module chunks = 1